import { createLocalStoragePersister } from '@client/utils/data/zustand';
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export const useDebugStore = create<DebugStore>()(
    persist<DebugStore>(
        (set) => ({
            isForceDebugEnabledFlag: false,
            setIsForceDebugEnabledFlag: (value) => set({ isForceDebugEnabledFlag: value }),
            isPreloadLogsEnabled: false,
            setIsPreloadLogsEnabled: (value) => set({ isPreloadLogsEnabled: value }),
            isPosthogLogsEnabled: false,
            setIsPosthogLogsEnabled: (value) => set({ isPosthogLogsEnabled: value }),
            isAppVersionLogsEnabled: false,
            setIsAppVersionLogsEnabled: (value) => set({ isAppVersionLogsEnabled: value }),
            isUIDebugInfoEnabledFlag: false,
            setIsUIDebugInfoEnabledFlag: (value) => set({ isUIDebugInfoEnabledFlag: value }),
        }),
        {
            name: 'debug',
            storage: createLocalStoragePersister<DebugStore>(),
        },
    ),
);

type DebugStore = {
    isForceDebugEnabledFlag: boolean;
    setIsForceDebugEnabledFlag: (value: boolean) => void;
    isPreloadLogsEnabled: boolean;
    setIsPreloadLogsEnabled: (value: boolean) => void;
    isPosthogLogsEnabled: boolean;
    setIsPosthogLogsEnabled: (value: boolean) => void;
    isAppVersionLogsEnabled: boolean;
    setIsAppVersionLogsEnabled: (value: boolean) => void;
    isUIDebugInfoEnabledFlag: boolean;
    setIsUIDebugInfoEnabledFlag: (value: boolean) => void;
};
